import { gql } from '@apollo/client'

const query = gql`
  query ShopifyCustomer($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      id
      addresses(first: 250) {
        edges {
          node {
            id
            address1
            address2
            country
            city
            province
            provinceCode
            zip
            company
            name
            phone
            firstName
            lastName
          }
        }
      }
      defaultAddress {
        id
        address1
        address2
        country
        city
        province
        provinceCode
        zip
        company
        name
        phone
        firstName
        lastName
      }
    }
  }
`

/**
 * https://help.shopify.com/en/api/storefront-api/reference/queryroot
 *
 * @param {{handle: string}} variables
 */
const queryShopifyCustomer = (client, variables) => client.query({ query, variables })

export default queryShopifyCustomer
